<template>
    <!-- Features -->
    <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-24 mx-auto">
        <!-- Grid -->
        <div class="md:grid md:grid-cols-2 md:items-start md:gap-12 xl:gap-32">
            <div class="flex justify-center items-center">
                <div class="w-1/2 h-auto">
                    <img
                        class="rounded-xl w-full h-auto object-cover object-center"
                        src="../assets/foto_sophron_website.jpg"
                        alt="Sophron"
                    />
                </div>
            </div>
            <!-- End Col -->

            <div class="mt-5 sm:mt-10 lg:mt-0">
                <div class="space-y-6 sm:space-y-8">
                    <!-- Title -->
                    <div class="space-y-2 md:space-y-4">
                        <h2
                            class="font-bold text-3xl lg:text-4xl font-header text-primary dark:text-gray-200 text-left"
                        >
                            About Waive
                        </h2>

                        <p class="text-secondary font-body text-left">
                            Hi, I'm Sophron, driven by a vision where AI is integrated into every aspect of daily business. The rapid advancement of AI technology inspired me to create Waive, a platform designed to guide businesses through AI's potential with clarity and confidence.
                        </p>
                        <h3
                            class="font-bold font-header text-header text-lg lg:text-xl text-primary dark:text-gray-200 text-left"
                        >
                            My background
                        </h3>
                        <p class="text-secondary font-body text-left">
                            With over 10 years of expertise in AI development, I stand at the intersection of innovation and practicality. My journey in the field of AI has been driven by a singular ambition: to harness the science-fiction-turned-reality of AI and channel it into tangible business success.
                        </p>
                        <h3
                            class="font-bold font-header text-lg lg:text-xl text-primary dark:text-gray-200 text-left"
                        >
                            What sets us apart
                        </h3>
                        <p class="text-secondary font-body text-left">
                            At Waive, we blend in-depth AI expertise with a personalized approach. We don't just integrate AI; we tailor solutions to your specific business needs, ensuring it works optimally for you. <br /><br />It's our commitment to not only adapt to AI's advancements but to make them intuitively work for your growth and innovation.
                        </p>
                    </div>
                    <!-- End Title -->
                </div>
            </div>
            <!-- End Col -->
        </div>
        <!-- End Grid -->
    </div>
    <!-- End Features -->
</template>

<script>
export default {
    name: "AboutUsSection",
    // You can add JavaScript logic here if needed
};
</script>

<style scoped>
/* No additional styles needed */
</style>